// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WN-z","twoColumnImage":"XN-z"};